import { colors } from '@mui/material';

const white = '#FFFFFF';
const black = '#000000';

// eslint-disable-next-line
export default {
  black,
  white,
  primary: {
    contrastText: white,
    dark: '#13345a', // colors.indigo[900],
    main: '#215897', // colors.indigo[500],
    light: '#799ac0', // colors.indigo[100]
  },
  secondary: {
    contrastText: white,
    dark: colors.blue[900],
    main: colors.blue.A400,
    light: colors.blue.A400,
  },
  error: {
    contrastText: white,
    dark: colors.red[900],
    main: colors.red[600],
    light: colors.red[400],
  },
  text: {
    primary: '#334155 !important', //colors.blueGrey[900]
    menu: '#FFFFFF',
    secondary: 'rgba(0, 0, 0, 0.6)',
    link: colors.blue[600],
  },
  link: colors.blue[800],
  icon: colors.blueGrey[600],
  background: {
    default: '#EBEEF2',
    paper: white,
  },
  divider: colors.grey[200],
};
